import React from 'react';
import ErrorPage from '../error/error_page';
const NotFound = () => {
    return (React.createElement(ErrorPage, { error: { name: 'Not Found', message: 'Page Not Found' } }));
};
export default NotFound;
